<template>
  <div :class="wrapClass">
    <div class="mb-3">
      <div class="row">
        <div class="col-12">
          <label class="font-middle">
            <span
              v-html="title"
            />
            <required-badge v-show="required" />
          </label>
        </div>
      </div>
      <label
        class="mt-description font-small text-dark-gray mb-3 description"
        v-html="description"
      />
    </div>
    <error-message :errors="errors" />
    <!-- v-html="description" は変数内でhtm"lタグを利用しているので、v-htmlを利用 -->
    <single-selection-buttons
      ref="SingleBtn"
      :options="options"
      :option-key="optionKey"
      :value-key="valueKey"
      :button-type="buttonType"
      :post-name="postName"
      :disabled="disabled"
      :clicked="clicked"
      :is-wrap="isWrap"
      :is-sp-radio-button="isSpRadioButton"
      @select="select"
    />
  </div>
</template>

<script>
import SingleSelectionButtons from "./SingleSelectionButtons.vue";
import ErrorMessage from "./ErrorMessage.vue";
import RequiredBadge from "./RequiredBadge.vue";

export default {
  components: {
    SingleSelectionButtons,
    ErrorMessage,
    RequiredBadge
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    optionKey: {
      type: String,
      default: "undefined"
    },
    valueKey: {
      type: String,
      default: "undefined"
    },

    // ボタンの形 角丸=tile 丸=round
    buttonType: {
      type: String,
      default: "tile"
    },
    postName: {
      type: String,
      default: "single_selected"
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clicked: {
      type: String,
      default: ""
    },
    errors: {
      type: Array,
      default() {
        return [];
      }
    },
    wrapClass: {
      type: String,
      default: "mb-4"
    },
    isWrap: {
      type: Boolean,
      default: false
    },
    isSpRadioButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    convertLabel(option) {
      if (this.optionKey === "undefined") {
        return String(option);
      }
      return String(option[this.optionKey]);
    },
    convertValue(option) {
      if (this.valueKey === "undefined") {
        return String(option);
      }
      return String(option[this.valueKey]);
    },
    select(option) {
      this.$emit("select", option);
    }
  }
};
</script>

<style scoped>
.description {
  display: block;
}
.disabled label:not(.active) {
  border-color: #ebebeb;
  color: #b8c2cc;
}
</style>
